import React, { useEffect, useRef, useState } from 'react'
import {
    Link,
    Navigate
} from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import useKeypress from 'react-use-keypress';
import { toast } from 'react-toastify';

import QR from 'qrcode-base64'
import { onMessageListener } from '../firebase';

import { fetchRequest, ROOT_URL } from '../fetchRequest';
import { priceFormat } from '../utils';

import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image'
import InputGroup from 'react-bootstrap/InputGroup';

const ChargeModal = ({ pageFocused = false, onCloseChargeModal = {}, fcmToken = null }) => {
    const mountedRef = useRef(false);
    const dispatch = useDispatch();
    const { currentUser } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [nfcCode, setNfcCode] = useState('');
    const [nfcListening, setNfcListening] = useState(false);

    const [chargeQrImage, setChargeQrImage] = useState(null);
    const [chargeCardDisabled, setChargeCardDisable] = useState(false);
    const [chargeCardReading, setChargeCardReading] = useState(false);
    const [selectedChargeOption, setSelectedChargeOption] = useState('FOOD');
    const [chargeOptions, setChargeOptions] = useState([
        {
            name: 'Хоол',
            value: 'FOOD'
        },
        {
            name: 'Дэлгүүр',
            value: 'SHOP'
        }
    ]);
    const [chargeAmount, setChargeAmount] = useState('');
    const [chargeItemTypes, setChargeItemTypes] = useState([]);
    const [chargeSelectedTypeId, setChargeSelectedTypeId] = useState(null);
    const [tempNfc, setTempNfc] = useState('');

    const [updateView, setUpdateView] = useState(false);

    onMessageListener().then(payload => {
        if (payload && payload?.notification) {
            toast.success(payload?.notification?.title, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false
            });
            if (chargeQrImage) {
                onCloseChargeModal()
            }
        }
    }).catch(err => console.log('failed: ', err));

    useKeypress(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Enter'], (event) => {
        if (nfcListening) {
            if (event.key?.toLowerCase() === 'enter') {
                submitCharge(nfcCode)
            } else {
                setNfcCode(nfcCode + event?.key);
            }
        }
    });

    useEffect(() => {
        if (!mountedRef?.current) {
            mountedRef.current = true;

            if (pageFocused) {
                setNfcListening(false);
            } else {
                setNfcListening(false);
            }
        }
    }, [pageFocused]);

    const submitCharge = (nfcCode = null, itemType = null) => {
        setChargeCardDisable(true);
        setLoading(true);
        setNfcCode('');
        let bodyParams = {
            school: currentUser?.school,
            nfcCode,
            amount: chargeAmount,
            type: selectedChargeOption,
            fcmToken,
            itemType
        }
        fetchRequest("app/kiosk/sale/charge", 'POST', bodyParams)
            .then(res => {
                setLoading(false);
                if (res?.success) {
                    if (res?.qrImage) {
                        setTempNfc('');
                        setChargeCardDisable(false);
                        setChargeQrImage(res?.qrImage);
                    } else if (res?.itemTypes && res?.itemTypes.length > 1) {
                        setTempNfc(nfcCode);
                        setChargeCardReading(false);
                        setChargeItemTypes(res?.itemTypes.map((obj) => {
                            return {
                                value: obj?.id,
                                name: obj?.name
                            }
                        }));
                    }
                } else {
                    setTempNfc('');
                    setChargeCardDisable(false);

                    toast.warning(res?.message || 'Картын мэдээлэл олдсонгүй', {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    })
                }
            }).catch(e => {
                setLoading(false);
                setTempNfc('');
                setChargeCardDisable(false);

                toast.warning('Хүсэлт илгээхэд алдаа гарлаа', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                })
            })

    }

    return (
        <>
            <Modal
                show={true}
                backdrop="static"
                dialogClassName="modal-95w"
                onHide={onCloseChargeModal}>
                <Modal.Body className={'p-0'} style={{ display: 'flex', flexDirection: 'column' }}>
                    <Row style={{ marginTop: 20, marginBottom: 10 }}>
                        <Col className='text-center'>
                            <Button type={'button'} className='btn-close-shop' variant="secondary" onClick={onCloseChargeModal}>
                                <Image
                                    alt='close'
                                    className="icon-close"
                                    src={`/assets/images/ic_close.png`} />
                            </Button>
                        </Col>
                    </Row>

                    {
                        chargeQrImage
                            ?
                            <div style={{ height: '100%', paddingTop: '10%', textAlign: 'center' }}>
                                <p style={{ marginLeft: 30, marginRight: 30 }}>Банкны аппликейшнаар доорх QR кодыг уншуулж эрхээ цэнэглэх боломжтой.</p>
                                <p style={{ marginLeft: 30, marginRight: 30 }}><span style={{ fontSize: 12 }}>/Төлбөр төлөгдсөний дараа уг хуудсыг хаана уу./</span></p>
                                <img src={`data:image/png;base64,${chargeQrImage}`} style={{ objectFit: 'contain' }} />

                                <Row style={{ marginTop: 50 }}>
                                    <Col>
                                        <button type={'button'} className="btn-close-shop btn btn-secondary"
                                            style={{ color: '#000' }}
                                            onClick={() => {
                                                setChargeQrImage(null);
                                                setSelectedChargeOption('FOOD');
                                                setChargeSelectedTypeId(null);
                                                setChargeItemTypes([]);
                                                setLoading(false)
                                                setChargeAmount('');
                                                setChargeCardReading(false);
                                                setChargeCardDisable(false);
                                            }}>
                                            Дахин эхлэх
                                        </button>
                                    </Col>
                                </Row>
                            </div>
                            :
                            <div style={{ height: '100%', paddingTop: '10%' }}>
                                <Row>
                                    <Col xs={1} md={3}></Col>
                                    <Col xs={10} md={6}>
                                        <Row>
                                            <label>Цэнэглэлтийн төрөл:</label>
                                            <ButtonGroup>
                                                {chargeOptions.map((radio, idx) => (
                                                    <ToggleButton
                                                        key={idx}
                                                        id={`saletype-${idx}`}
                                                        type="radio"
                                                        variant={'outline-secondary'}
                                                        name="saletype"
                                                        value={radio.value}
                                                        checked={selectedChargeOption === radio.value}
                                                        onChange={(e) => setSelectedChargeOption(e.currentTarget.value)}
                                                    >
                                                        {radio.name}
                                                    </ToggleButton>
                                                ))}
                                            </ButtonGroup>
                                        </Row>
                                        <Row className={'mt-20'}>
                                            <label>Үнийн дүн:</label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>₮</InputGroup.Text>
                                                <Form.Control aria-label="Үнийн дүн"
                                                    onChange={(e) => setChargeAmount(e.target.value)}
                                                    value={chargeAmount}
                                                    placeholder="Цэнэглэх дүн оруулна уу" />
                                            </InputGroup>
                                        </Row>

                                        {
                                            chargeItemTypes && chargeItemTypes.length > 1
                                                ? <>
                                                    <Row>
                                                        <label>Эрхийн төрөл:</label>
                                                        <ButtonGroup>
                                                            {chargeItemTypes.map((radio, idx) => (
                                                                <ToggleButton
                                                                    key={idx}
                                                                    id={`itemtype-${idx}`}
                                                                    type="radio"
                                                                    variant={'outline-secondary'}
                                                                    name="itemtype"
                                                                    value={radio.value}
                                                                    checked={chargeSelectedTypeId === radio.value}
                                                                    onChange={(e) => setChargeSelectedTypeId(e.currentTarget.value)}
                                                                >
                                                                    {radio.name}
                                                                </ToggleButton>
                                                            ))}
                                                        </ButtonGroup>
                                                    </Row>
                                                    <Row style={{ marginTop: 20 }}>
                                                        <Col className="text-center">
                                                            {
                                                                loading
                                                                    ?
                                                                    <>
                                                                        <Spinner animation="border" size='md' />
                                                                        <p>{'Түр хүлээнэ үү'}</p>
                                                                    </>
                                                                    :
                                                                    <button type={'button'}
                                                                        className='btn-main'
                                                                        onClick={() => {
                                                                            if (!chargeSelectedTypeId) {
                                                                                toast.warning('Эрхийн төрөл сонгоно уу', {
                                                                                    position: "top-right",
                                                                                    autoClose: 2000,
                                                                                    hideProgressBar: true,
                                                                                    closeOnClick: true,
                                                                                    pauseOnHover: true,
                                                                                    draggable: false
                                                                                })
                                                                                return;
                                                                            }
                                                                            submitCharge(tempNfc, chargeSelectedTypeId)
                                                                        }}>
                                                                        Төлбөр төлөх
                                                                    </button>
                                                            }

                                                        </Col>
                                                    </Row>
                                                </>
                                                :
                                                <Row className={'mt-20 text-center'}>
                                                    <Col>
                                                        {
                                                            chargeCardReading
                                                                ?
                                                                <>
                                                                    <Spinner animation="border" size='md' />
                                                                    <p>{loading ? 'Түр хүлээнэ үү' : 'Сурагчийн / Ажилтны картаа уншуулна уу'}</p>
                                                                </>
                                                                :
                                                                <button
                                                                    type={'button'}
                                                                    className='btn-main'
                                                                    disabled={false}
                                                                    onClick={() => {
                                                                        if (chargeAmount >= 200) {
                                                                            setNfcListening(true);
                                                                            setChargeCardDisable(false);
                                                                            setChargeCardReading(true);
                                                                        } else {
                                                                            toast.warning('Цэнэглэх үнийн дүн 200₮-с дээш байх шаардлагатай', {
                                                                                position: "top-right",
                                                                                autoClose: 2000,
                                                                                hideProgressBar: true,
                                                                                closeOnClick: true,
                                                                                pauseOnHover: true,
                                                                                draggable: false
                                                                            })
                                                                        }
                                                                    }}>
                                                                    Цэнэглэх
                                                                </button>
                                                        }

                                                    </Col>
                                                </Row>
                                        }
                                    </Col>
                                    <Col xs={1} md={3}></Col>
                                </Row>

                            </div>
                    }
                </Modal.Body>
            </Modal>
        </>
    );

}
export default ChargeModal;